'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var react_redux_1 = require('react-redux');
var Actions = require('./Actions');
var Dropzone = require('react-dropzone');
;
function selectState(state) {
    return state;
}
;

var Component = (function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        var _this = this;

        _classCallCheck(this, Component);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        _get(Object.getPrototypeOf(Component.prototype), 'constructor', this).apply(this, args);
        this.playback = {
            setTimeoutReference: null,
            isPlaying: false
        };
        this.timeFromStart = function (pos1) {
            return Math.floor((_this.props.stateHistory.timestamps[pos1] - _this.props.stateHistory.timestamps[0 + 1]) / 1000);
        };
        this.currentTime = function () {
            return _this.timeFromStart(_this.props.stateHistory.current);
        };
        this.totalTime = function () {
            return _this.timeFromStart(_this.props.stateHistory.timestamps.length - 1);
        };
        this.playUntilEnd = function () {
            if (_this.props.stateHistory.current >= _this.props.stateHistory.timestamps.length - 1) {
                return _this.stopPlackback();
            } else {
                var nextActionInMiliseconds = _this.props.stateHistory.timestamps[_this.props.stateHistory.current + 1] - _this.props.stateHistory.timestamps[_this.props.stateHistory.current];
                // Dispatch action after gap and call self
                setTimeout(function () {
                    _this.props.dispatch(Actions.selectHistory(_this.props.stateHistory.current + 1));
                    _this.playUntilEnd();
                }, nextActionInMiliseconds);
            }
        };
        this.stopPlackback = function () {
            clearTimeout(_this.playback.setTimeoutReference);
            _this.playback.isPlaying = false;
            _this.forceUpdate(); // refresh immediately to show new play button status, needed becuase we are cheating and not modifying props
        };
        this.startPlayback = function () {
            _this.playback.isPlaying = true;
            _this.playUntilEnd();
            _this.forceUpdate();
        };
        this.selectHistory = function (e) {
            console.log(e);
            console.log('here');
            _this.props.dispatch(Actions.selectHistory(parseInt(e.target.value, 10)));
        };
        this.changeHistory = function (step) {
            var selected = _this.props.stateHistory.current + step;
            // Upper & lower bound
            if (selected > _this.props.stateHistory.history.length - 1) {
                selected = _this.props.stateHistory.history.length - 1;
            } else if (selected < 1) {
                selected = 1;
            }
            _this.props.dispatch(Actions.selectHistory(selected));
        };
        /**
         * Read uploaded json file and dispatch action
         */
        this.uploadHistory = function (files) {
            var blob = files[0].slice(0);
            var reader = new FileReader();
            reader.onloadend = function () {
                var json = JSON.parse(reader.result);
                _this.props.dispatch(Actions.uploadHistory(json));
            };
            reader.readAsText(blob);
        };
    }

    _createClass(Component, [{
        key: 'downloadHistory',
        value: function downloadHistory(e) {
            e.target.href = 'data:text/json;charset=utf-8, ' + encodeURIComponent(JSON.stringify(this.props.stateHistory));
        }
    }, {
        key: 'render',
        value: function render() {
            console.log('everything fine here?');
            return React.createElement("div", { "style": Component.styles.container }, React.createElement("div", null, React.createElement("div", { "style": { float: 'right' } }, React.createElement("span", { "style": this.playback.isPlaying ? { marginRight: '10px', display: 'inline-block' } : {} }, this.playback.isPlaying && this.currentTime() + 's|' + this.totalTime() + 's'), this.props.stateHistory.current, " / ", this.props.stateHistory.history.length - 1, "     ", React.createElement("button", { "onClick": this.changeHistory.bind(this, -1), "title": 'Previous state', "style": this.playback.isPlaying || this.props.stateHistory.current <= 1 ? Object.assign({}, Component.styles.button, Component.styles.disabled) : Component.styles.button }, '<'), "  ", React.createElement("button", { "onClick": this.changeHistory.bind(this, 1), "title": 'Next state', "style": this.playback.isPlaying || this.props.stateHistory.current >= this.props.stateHistory.history.length - 1 ? Object.assign({}, Component.styles.button, Component.styles.disabled) : Component.styles.button }, '>'), "  ", React.createElement("button", { "onClick": this.playback.isPlaying ? this.stopPlackback : this.startPlayback, "title": 'Realtime Playblack', "style": this.props.stateHistory.current >= this.props.stateHistory.history.length - 1 ? Object.assign({}, Component.styles.button, Component.styles.disabled) : Component.styles.button }, this.playback.isPlaying ? '■' : '▸'), "  ", React.createElement("a", { "href": '#', "onClick": this.downloadHistory.bind(this), "download": 'state.json', "title": 'Download state', "style": Object.assign({}, Component.styles.button, Component.styles.blueBg, Component.styles.links) }, "⇓"), "  ", React.createElement(Dropzone, { "multiple": false, "title": 'Upload state', "onDrop": this.uploadHistory, "style": Object.assign({ float: 'right' }, Component.styles.button, Component.styles.clipboard) }, "⇧")), React.createElement("div", { "style": { width: 'auto', overflow: 'hidden', paddingRight: '19px' } }, React.createElement("input", { "type": 'range', "step": 1, "min": 1, "style": Component.styles.input, "max": this.props.stateHistory.history.length - 1, "value": '' + this.props.stateHistory.current, "onChange": this.selectHistory.bind(this) })), React.createElement("div", { "style": Component.styles.actions }, this.props.stateHistory.actions[this.props.stateHistory.current])));
        }
    }]);

    return Component;
})(React.Component);

Component.styles = {
    button: {
        backgroundColor: '#518D21',
        borderRadius: '3px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        fontSize: '20px',
        width: '26px',
        height: '22px',
        lineHeight: '20px',
        fontWeight: 'bold',
        padding: '0px 1px',
        boxSizing: 'content-box',
        color: 'white',
        textAlign: 'center',
        cursor: 'pointer'
    },
    disabled: {
        backgroundColor: 'rgb(102, 102, 102)',
        cursor: 'default'
    },
    input: {
        margin: '4px 0px',
        outline: 'none',
        border: 'none',
        overflow: 'hidden',
        width: '100%',
        height: '16px'
    },
    blueBg: {
        backgroundColor: 'rgb(33, 122, 141)'
    },
    clipboard: {
        backgroundColor: 'transparent',
        // color: 'rgb(33, 122, 141)',
        color: '#6FB3D2',
        borderColor: '#6FB3D2',
        borderStyle: 'dashed'
    },
    container: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.3)',
        backgroundColor: '#2A2F3A',
        // maxWidth: '1000px',
        color: 'white',
        padding: '12px 12px 8px',
        left: 0,
        boxSizing: 'border-box',
        zIndex: 1000
    },
    links: {
        padding: '0px 6px'
    },
    actions: {
        fontSize: 'smaller',
        float: 'right',
        marginTop: '6px'
    }
};
exports['default'] = react_redux_1.connect(selectState)(Component);


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-state-history/lib/Component.js
 ** module id = 1700
 ** module chunks = 0
 **/